import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Share } from "../../Share/Share";
import { useResolveUserPublicProfilePagePath } from "../../Pages/UserPublicProfilePage/path";
import { IconButton, ShareIcon, Tooltip } from "@parkschannel/ui";
export const ActionsRow = (param)=>{
    let { user , children  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-6",
        children: [
            /*#__PURE__*/ _jsx(Share, {
                data: {
                    url: useResolveUserPublicProfilePagePath(user.cognito_id),
                    title: "".concat(user.name)
                },
                children: /*#__PURE__*/ _jsx(Tooltip, {
                    overlay: "Share with friends and family",
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        icon: /*#__PURE__*/ _jsx(ShareIcon, {
                            className: "w-6 h-6 text-primary-500"
                        }),
                        variant: "base"
                    })
                })
            }),
            children
        ]
    });
};
